var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('portal', {
    attrs: {
      "to": "lm-modal"
    }
  }, [_vm.isShow ? [_c('div', {
    staticClass: "Modal ModalPaymentTax Popup__depth2"
  }, [_c('div', {
    staticClass: "Popup__centered"
  }, [_c('div', {
    ref: "container",
    staticClass: "Popup__container Popup__size-sm"
  }, [_c('div', {
    staticClass: "Popup__top"
  }, [_c('h5', {
    staticClass: "Popup__title"
  }, [_vm._v(" " + _vm._s(_vm.tt('거래명세서 다운로드')) + " ")]), _c('button', {
    staticClass: "Popup__close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/popup-close.svg"),
      "alt": "close"
    }
  })])]), _c('div', {
    staticClass: "Popup__content"
  }, [_c('h5', [_vm._v(_vm._s(_vm.tt('기업정보')))]), _c('div', {
    staticClass: "Popup__input-field"
  }, [_c('p', [_vm._v(_vm._s(_vm.tt('상호명'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.nameOfCompany,
      expression: "form.nameOfCompany"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.tt('법인명을 입력해주세요')
    },
    domProps: {
      "value": _vm.form.nameOfCompany
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "nameOfCompany", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "Popup__input-field"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.tt('사업자등록번호(10자리)')) + " "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _c('input', {
    "class": {
      error: _vm.registrationNumberError
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tt('10자리 사업자등록번호를 입력해주세요'),
      "maxlength": "12"
    },
    domProps: {
      "value": _vm.form.registrationNumber
    },
    on: {
      "input": _vm.autoTraderNumber
    }
  }), _vm.registrationNumberError ? _c('span', {
    staticClass: "input-error-msg"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/input-icon-warning.svg")
    }
  }), _c('p', [_vm._v(" " + _vm._s(_vm.tt('유효하지 않은 사업자등록번호입니다.')) + " ")])]) : _vm._e()]), _c('div', {
    staticClass: "Popup__input-field"
  }, [_c('p', [_vm._v(_vm._s(_vm.tt('대표자명'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.tt('대표자 이름을 입력해주세요')
    },
    domProps: {
      "value": _vm.form.nameOfRepresentative
    },
    on: {
      "input": _vm.inputNameOfRepresentative
    }
  })]), _c('div', {
    staticClass: "Popup__input-field"
  }, [_c('p', [_vm._v(_vm._s(_vm.tt('업태')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.bizType,
      expression: "form.bizType"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.tt('업태를 입력해주세요')
    },
    domProps: {
      "value": _vm.form.bizType
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "bizType", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "Popup__input-field"
  }, [_c('p', [_vm._v(_vm._s(_vm.tt('종목')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.bizClass,
      expression: "form.bizClass"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.tt('종목을 입력해주세요')
    },
    domProps: {
      "value": _vm.form.bizClass
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "bizClass", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "Popup__input-field"
  }, [_c('p', [_vm._v(_vm._s(_vm.tt('전화번호')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.phone,
      expression: "form.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.tt('전화번호를 입력해주세요')
    },
    domProps: {
      "value": _vm.form.phone
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "phone", $event.target.value);
      }, _vm.inputTel]
    }
  })]), _c('div', {
    staticClass: "Popup__input-field"
  }, [_c('p', [_vm._v(_vm._s(_vm.tt('주소')))]), _c('AddressInput', {
    attrs: {
      "hasPostcode": false,
      "postcode": _vm.form.postcode,
      "address": _vm.form.address,
      "addressDetail": _vm.form.addressDetail,
      "addressPlaceholder": "주소를 검색해주세요"
    },
    on: {
      "search": _vm.changeAddress
    }
  })], 1)]), _c('div', {
    staticClass: "Popup__bottom"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.isDownloading,
      "spinner-variant": "primary",
      "rounded": "sm"
    }
  }, [_c('button', {
    staticClass: "Btn__yellow",
    attrs: {
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.downloadInvoice
    }
  }, [_vm._v(" " + _vm._s(_vm.tt('다운로드')) + " ")])])], 1)])])]), _c('div', {
    staticClass: "Popup__background Popup__depth2"
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }